import { type PropsWithChildren } from 'react';

export const Legend = ({ children }: PropsWithChildren) =>
  children !== undefined && children !== null ? (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>{children}</>
  ) : null;

Legend['displayName'] = 'MeterBarLayout.Legend';
